import { NavLink, Outlet } from 'react-router-dom'
import { Stethoscope, Users } from 'lucide-react'

// Horizontal tab shell for ตารางเวร (/manager/schedule) — same pattern as
// EmployeeLayout. Two rosters, two tables, one section: doctor_timetable and
// employee_timetable answer the same question ("who is in, when, where") for
// two different populations, so they share a shell but not a page.
//
// ขอเวร and การลา are NESTED one level down, inside the ทันตแพทย์ tab
// (DoctorScheduleLayout) — they are doctor-only, and as siblings here they sat
// beside the EMPLOYEE roster and implied they applied to it too. The ทันตแพทย์
// NavLink below deliberately has no `end`, so it stays active across all three
// of its children.
const TABS = [
  { to: 'doctor',        label: 'ทันตแพทย์', icon: Stethoscope,  hint: 'ตารางออกตรวจของหมอ' },
  { to: 'employee',      label: 'พนักงาน',   icon: Users,        hint: 'ตารางเวรพนักงาน · กะเช้า/กะบ่าย/ลา' },
]

export default function ScheduleLayout() {
  return (
    <div className="px-10 py-8">
      <h1 className="text-[22px] font-semibold text-slate-900 tracking-tight mb-1">ตารางเวร</h1>
      <p className="text-[13.5px] text-slate-500 mb-4">จัดตารางออกตรวจของทันตแพทย์ และตารางเวรของพนักงาน</p>

      <div className="border-b border-slate-200 -mx-1 mb-6">
        <nav className="flex items-end gap-1 px-1 overflow-x-auto no-scrollbar">
          {TABS.map(({ to, label, icon: Icon, hint }) => (
            <NavLink
              key={to}
              to={`/manager/schedule/${to}`}
              title={hint}
              className={({ isActive }) =>
                `relative flex items-center gap-1.5 px-3 py-2.5 text-[14px] font-medium whitespace-nowrap transition-colors ${
                  isActive ? 'text-brand-700' : 'text-slate-500 hover:text-slate-900'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={14} strokeWidth={1.75} />
                  <span>{label}</span>
                  {isActive && <span className="absolute left-2 right-2 -bottom-px h-[2px] bg-brand-600 rounded-full" />}
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  )
}
